// Modules
import { useId } from 'react';
import cn from 'classnames';

// Types
import type { TSwitchProps } from './Switch.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { kebabCase } from '../../helpers/typography';

// Constants
import { INPUT_TYPE, SWITCH_DEFAULT_PROPS, SWITCH_LABEL_POSITION, SWITCH_TYPE } from './Switch.constant';

const Switch = (props: TSwitchProps) => {
  const {
    className,
    disabled,
    fieldClassName,
    fieldStyle,
    id,
    inputClassName,
    inputStyle,
    label,
    labelClassName,
    labelPosition = SWITCH_DEFAULT_PROPS.labelPosition,
    labelStyle,
    size = SWITCH_DEFAULT_PROPS.size,
    style,
    toggleClassName,
    toggleStyle,
    type = SWITCH_DEFAULT_PROPS.type,
    ...restProps
  } = props;
  const initId = useId();
  const inputId = id || `legion_switch_${kebabCase(initId)}`;
  const inputType = type === SWITCH_TYPE.multiple ? INPUT_TYPE.checkbox : INPUT_TYPE.radio;
  const isLeftLabel = labelPosition === SWITCH_LABEL_POSITION.left;

  const switchCN = cn(styles.legion_switch, className, styles[size!], {
    [styles.disabled]: !!disabled,
    [styles.left_label]: isLeftLabel
  });
  const toggleCN = cn(styles.switch_toggle, toggleClassName);
  const fieldCN = cn(styles.switch_field, fieldClassName);
  const labelCN = cn(styles.switch_label, labelClassName);

  return (
    <div className={switchCN} style={style}>
      <div className={fieldCN} style={fieldStyle}>
        <input className={inputClassName} id={inputId} type={inputType} disabled={disabled}
               style={inputStyle} {...restProps}/>
        <span className={toggleCN} style={toggleStyle}/>
      </div>
      {label && (
        <label htmlFor={inputId} className={labelCN} style={labelStyle}>
          {label}
        </label>
      )}
    </div>
  );
};

export default Switch;
